import React, { createContext, useContext, useEffect, useState } from "react";
import { vendorApi } from "../lib/vendor-api";

const VendorAuthContext = createContext(null);

export function VendorAuthProvider({ children }) {
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("adams_vendor_token");
    if (!token) {
      setLoading(false);
      return;
    }
    vendorApi
      .get("/vendor/auth/me")
      .then((r) => setVendor(r.data))
      .catch(() => localStorage.removeItem("adams_vendor_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (mobile, password) => {
    const { data } = await vendorApi.post("/vendor/auth/login", { mobile, password });
    localStorage.setItem("adams_vendor_token", data.token);
    setVendor(data.vendor);
    return data.vendor;
  };

  const register = async (payload) => {
    const { data } = await vendorApi.post("/vendor/auth/register", payload);
    localStorage.setItem("adams_vendor_token", data.token);
    setVendor(data.vendor);
    return data.vendor;
  };

  const logout = () => {
    localStorage.removeItem("adams_vendor_token");
    setVendor(null);
    window.location.href = "/vendor/login";
  };

  const refresh = async () => {
    try {
      const { data } = await vendorApi.get("/vendor/auth/me");
      setVendor(data);
      return data;
    } catch {
      return null;
    }
  };

  return (
    <VendorAuthContext.Provider value={{ vendor, loading, login, register, logout, refresh, setVendor }}>
      {children}
    </VendorAuthContext.Provider>
  );
}

export const useVendorAuth = () => useContext(VendorAuthContext);
